// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  container-type: inline-size;
  color: #253750;
  font-size: 13px;
}

.material-symbols-outlined {
  line-height: 1;
}

.pp {
  display: flex;
  flex-direction: column;
  max-height: 90vh;
  background: #fff;
}

/* ---------- top bar ---------- */
.pp-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 16px 12px 20px;
  border-bottom: 1px solid #edf1f6;
  background: #fbfcfe;
  flex-shrink: 0;
}

.pp-bar-title {
  display: flex;
  align-items: center;
  gap: 10px;
}
.pp-bar-title > .material-symbols-outlined {
  display: grid;
  place-items: center;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: color-mix(in srgb, var(--primary-color) 10%, white);
  color: var(--primary-color);
  font-size: 18px;
}
.pp-bar-title strong {
  display: block;
  color: #172b46;
  font-size: 13px;
  font-weight: 600;
}
.pp-bar-title small {
  color: #7d8a9d;
  font-size: 11px;
}

.pp-close {
  display: grid;
  place-items: center;
  width: 34px;
  height: 34px;
  border: 1px solid #dce5ef;
  border-radius: 8px;
  background: #fff;
  color: #53647a;
  cursor: pointer;
}
.pp-close:hover {
  color: var(--primary-color);
  border-color: color-mix(in srgb, var(--primary-color) 25%, white);
}
.pp-close:focus {
  outline: none;
}
.pp-close:focus-visible {
  outline: 2px solid color-mix(in srgb, var(--primary-color) 40%, white);
  outline-offset: 2px;
}

.pp-body {
  overflow-y: auto;
  padding: 24px;
  scrollbar-width: thin;
}

/* ---------- hero: gallery + buy box ---------- */
.pp-hero {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 32px;
  align-items: start;
}

.pp-main-image {
  display: grid;
  place-items: center;
  aspect-ratio: 1/1;
  max-height: 420px;
  width: 100%;
  border: 1px solid #edf1f6;
  border-radius: 12px;
  background: #fbfcfe;
  overflow: hidden;
  position: relative;
}
.pp-main-image img {
  position: absolute;
  inset: 20px;
  width: calc(100% - 40px);
  height: calc(100% - 40px);
  object-fit: contain;
}

.pp-no-image {
  display: grid;
  justify-items: center;
  gap: 6px;
  color: #8491a3;
  font-size: 12px;
}
.pp-no-image .material-symbols-outlined {
  font-size: 36px;
}

.pp-thumbs {
  display: flex;
  gap: 8px;
  margin-top: 10px;
  overflow-x: auto;
  scrollbar-width: thin;
}

.pp-thumb {
  flex: 0 0 64px;
  height: 64px;
  padding: 4px;
  border: 1px solid #e2e9f2;
  border-radius: 8px;
  background: #fff;
  cursor: pointer;
}
.pp-thumb img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.pp-thumb.active {
  border-color: var(--primary-color);
  box-shadow: 0 0 0 1px var(--primary-color);
}

.pp-info {
  min-width: 0;
}

.pp-brand {
  margin: 0 0 6px;
  color: var(--primary-color);
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.4px;
  text-transform: uppercase;
}

.pp-name {
  margin: 0;
  color: #172b46;
  font-size: 22px;
  line-height: 30px;
  font-weight: 600;
  overflow-wrap: anywhere;
}

.pp-meta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 16px;
  margin-top: 10px;
}

.pp-rating {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.pp-rating small {
  color: #8491a3;
  font-size: 11px;
}
.pp-rating ::ng-deep .ant-rate {
  font-size: 14px;
}
.pp-rating ::ng-deep .ant-rate-star:not(:last-child) {
  margin-inline-end: 3px;
}

.pp-sku {
  padding: 2px 8px;
  border-radius: 5px;
  background: #f1f6fd;
  color: #6480a4;
  font-size: 11px;
}

.pp-seller {
  margin: 10px 0 0;
  color: #7d8a9d;
  font-size: 12px;
}
.pp-seller strong {
  color: #35445b;
  font-weight: 500;
}

.pp-price {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 6px;
  margin-top: 20px;
  padding-top: 18px;
  border-top: 1px solid #edf1f6;
}
.pp-price .pp-currency {
  color: #35445b;
  font-size: 14px;
  font-weight: 600;
}
.pp-price .pp-amount {
  color: #172b46;
  font-size: 28px;
  line-height: 1;
  font-weight: 700;
}
.pp-price .pp-unit {
  color: #7d8a9d;
  font-size: 12px;
}

.pp-vat {
  margin: 6px 0 0;
  color: #8491a3;
  font-size: 11px;
}

.pp-option {
  margin-top: 18px;
}

.pp-option-label {
  display: block;
  margin-bottom: 8px;
  color: #53647a;
  font-size: 11px;
  font-weight: 500;
  letter-spacing: 0.3px;
  text-transform: uppercase;
}

.pp-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.pp-chip {
  min-height: 34px;
  padding: 6px 14px;
  border: 1px solid #dce5ef;
  border-radius: 8px;
  background: #fff;
  color: #35445b;
  font: inherit;
  font-size: 12px;
  cursor: pointer;
}
.pp-chip:hover {
  border-color: color-mix(in srgb, var(--primary-color) 30%, white);
}
.pp-chip.active {
  border-color: var(--primary-color);
  background: color-mix(in srgb, var(--primary-color) 7%, white);
  color: var(--primary-color);
  font-weight: 500;
}

.pp-buy {
  display: flex;
  gap: 10px;
  margin-top: 22px;
}

.pp-qty {
  display: inline-flex;
  align-items: center;
  height: 44px;
  border: 1px solid #dce5ef;
  border-radius: 8px;
  overflow: hidden;
}
.pp-qty button {
  display: grid;
  place-items: center;
  width: 38px;
  height: 100%;
  border: 0;
  background: #fbfcfe;
  color: #8491a3;
  cursor: not-allowed;
}
.pp-qty button .material-symbols-outlined {
  font-size: 18px;
}
.pp-qty > span {
  min-width: 40px;
  text-align: center;
  font-weight: 600;
  color: #172b46;
}

.pp-cart {
  flex: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 44px;
  border: 0;
  border-radius: 8px;
  background: var(--primary-color);
  color: #fff;
  font: inherit;
  font-size: 13px;
  font-weight: 600;
  opacity: 0.55;
  cursor: not-allowed;
}
.pp-cart .material-symbols-outlined {
  font-size: 20px;
}

.pp-note {
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 10px 0 0;
  color: #8491a3;
  font-size: 11px;
}
.pp-note .material-symbols-outlined {
  font-size: 15px;
}

.pp-sample {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-top: 14px;
  color: var(--primary-color);
  font-size: 12px;
  font-weight: 500;
}
.pp-sample .material-symbols-outlined {
  font-size: 18px;
}

/* ---------- tabs ---------- */
.pp-tabs {
  display: flex;
  gap: 4px;
  margin-top: 32px;
  border-bottom: 1px solid #e2e9f2;
  overflow-x: auto;
  scrollbar-width: none;
}
.pp-tabs button {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 10px 14px;
  border: 0;
  border-bottom: 2px solid transparent;
  margin-bottom: -1px;
  background: transparent;
  color: #7d8a9d;
  font: inherit;
  font-size: 13px;
  font-weight: 500;
  white-space: nowrap;
  cursor: pointer;
}
.pp-tabs button:hover {
  color: #35445b;
}
.pp-tabs button.active {
  color: var(--primary-color);
  border-bottom-color: var(--primary-color);
}

.pp-count {
  padding: 0 6px;
  border-radius: 10px;
  background: #f1f3f7;
  color: #7d8a9d;
  font-size: 10px;
  line-height: 16px;
}

.pp-panel {
  padding: 20px 0 4px;
}
.pp-panel h3 {
  margin: 0 0 10px;
  color: #172b46;
  font-size: 14px;
  font-weight: 600;
}

.pp-desc {
  margin: 0;
  color: #53647a;
  line-height: 1.65;
  white-space: pre-wrap;
}

.pp-empty {
  margin: 0;
  color: #8491a3;
}

.pp-empty-state {
  display: grid;
  justify-items: center;
  gap: 6px;
  padding: 28px 12px;
  border: 1px dashed #dce5ef;
  border-radius: 10px;
  color: #8491a3;
}
.pp-empty-state .material-symbols-outlined {
  font-size: 28px;
  color: #a9bad1;
}
.pp-empty-state p {
  margin: 0;
  font-size: 12px;
}

.pp-specs {
  display: grid;
  grid-template-columns: minmax(140px, 220px) 1fr;
  margin: 0;
  border: 1px solid #e2e9f2;
  border-radius: 10px;
  overflow: hidden;
}
.pp-specs dt,
.pp-specs dd {
  margin: 0;
  padding: 11px 14px;
  border-bottom: 1px solid #edf1f6;
}
.pp-specs dt {
  background: #fbfcfe;
  color: #7d8a9d;
  font-size: 12px;
}
.pp-specs dd {
  color: #35445b;
}
.pp-specs dt:nth-last-of-type(1),
.pp-specs dd:last-child {
  border-bottom: 0;
}

.pp-review-summary {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 14px;
}
.pp-review-summary strong {
  color: #172b46;
  font-size: 26px;
}
.pp-review-summary small {
  color: #8491a3;
}

.pp-review {
  padding: 14px 0;
  border-top: 1px solid #edf1f6;
}
.pp-review .pp-review-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}
.pp-review .pp-review-head strong {
  color: #172b46;
}
.pp-review .pp-review-head ::ng-deep .ant-rate {
  font-size: 12px;
}
.pp-review small {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 2px;
  color: #8491a3;
  font-size: 11px;
}
.pp-review p {
  margin: 8px 0 0;
  color: #53647a;
  line-height: 1.55;
}

.pp-verified {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  color: #36866a;
}
.pp-verified .material-symbols-outlined {
  font-size: 14px;
}

.pp-doc-group + .pp-doc-group {
  margin-top: 18px;
}

.pp-doc {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 14px;
  margin-bottom: 8px;
  border: 1px solid #e2e9f2;
  border-radius: 10px;
  color: inherit;
  text-decoration: none;
}
.pp-doc > .material-symbols-outlined:first-child {
  color: var(--primary-color);
  font-size: 22px;
}
.pp-doc > .material-symbols-outlined:last-child {
  color: #8491a3;
  font-size: 20px;
}
.pp-doc:hover {
  border-color: color-mix(in srgb, var(--primary-color) 30%, white);
}
.pp-doc:hover > .material-symbols-outlined:last-child {
  color: var(--primary-color);
}

.pp-doc-text {
  flex: 1;
  min-width: 0;
}
.pp-doc-text strong {
  display: block;
  color: #172b46;
  font-weight: 500;
}
.pp-doc-text small {
  color: #8491a3;
  font-size: 11px;
}

/* ---------- related products ---------- */
.pp-related {
  margin-top: 28px;
  padding-top: 20px;
  border-top: 1px solid #edf1f6;
}
.pp-related h3 {
  margin: 0 0 12px;
  color: #172b46;
  font-size: 14px;
  font-weight: 600;
}

.pp-related-row {
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: 170px;
  gap: 12px;
  overflow-x: auto;
  padding-bottom: 6px;
  scrollbar-width: thin;
}

.pp-card {
  display: grid;
  gap: 4px;
  padding: 10px;
  border: 1px solid #e2e9f2;
  border-radius: 10px;
}
.pp-card small {
  color: #8491a3;
  font-size: 10px;
}
.pp-card strong {
  color: #172b46;
  font-size: 12px;
  font-weight: 500;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.pp-card-img {
  display: grid;
  place-items: center;
  height: 120px;
  margin-bottom: 6px;
  border-radius: 8px;
  background: #fbfcfe;
  color: #a9bad1;
}
.pp-card-img img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.pp-card-price {
  color: #172b46;
  font-weight: 600;
  font-size: 12px;
}

/* ---------- theme tokens (all colours from the theme config) ---------- */
:host {
  --pp-ink: var(--primary-font-color, #172b46);
  --pp-text: var(--primary-font-color, #35445b);
  --pp-body: var(--secondary-grey-color, #53647a);
  --pp-muted: var(--secondary-grey-color, #8491a3);
  --pp-border: color-mix(in srgb, var(--grey-border, #D5D7DA) 70%, white);
  --pp-divider: color-mix(in srgb, var(--grey-border, #D5D7DA) 45%, white);
  --pp-soft: color-mix(in srgb, var(--primary-color) 3%, white);
  --pp-tint: color-mix(in srgb, var(--primary-color) 8%, white);
  --pp-tint-text: color-mix(in srgb, var(--primary-color) 75%, black);
  color: var(--pp-text);
}

.pp-name,
.pp-bar-title strong,
.pp-price .pp-amount,
.pp-qty > span,
.pp-panel h3,
.pp-related h3,
.pp-review strong,
.pp-review-summary strong,
.pp-doc-text strong,
.pp-card strong,
.pp-card-price {
  color: var(--pp-ink);
}

.pp-price .pp-currency,
.pp-seller strong,
.pp-chip,
.pp-specs dd {
  color: var(--pp-text);
}

.pp-desc,
.pp-review p,
.pp-option-label,
.pp-close {
  color: var(--pp-body);
}

.pp-bar-title small,
.pp-seller,
.pp-price .pp-unit,
.pp-vat,
.pp-note,
.pp-rating small,
.pp-tabs button,
.pp-empty,
.pp-empty-state,
.pp-specs dt,
.pp-review small,
.pp-review-summary small,
.pp-doc-text small,
.pp-card small,
.pp-no-image,
.pp-qty button {
  color: var(--pp-muted);
}

.pp-close,
.pp-thumb,
.pp-chip,
.pp-qty,
.pp-empty-state,
.pp-specs,
.pp-doc,
.pp-card,
.pp-tabs {
  border-color: var(--pp-border);
}

.pp-bar,
.pp-main-image,
.pp-price,
.pp-specs dt,
.pp-specs dd,
.pp-review,
.pp-related {
  border-color: var(--pp-divider);
}

.pp-bar,
.pp-main-image,
.pp-qty button,
.pp-specs dt,
.pp-card-img {
  background: var(--pp-soft);
}

.pp-sku,
.pp-count {
  background: var(--pp-tint);
  color: var(--pp-tint-text);
}

.pp-tabs button.active,
.pp-chip.active,
.pp-close:hover,
.pp-doc:hover > .material-symbols-outlined:last-child {
  color: var(--primary-color);
}

.pp-tabs button:hover:not(.active) {
  color: var(--pp-text);
}

.pp-chip.active,
.pp-thumb.active {
  border-color: var(--primary-color);
}

/* ---------- responsive ---------- */
@container (max-width: 720px) {
  .pp-hero {
    grid-template-columns: 1fr;
    gap: 20px;
  }
  .pp-main-image {
    max-height: 300px;
  }
  .pp-body {
    padding: 16px;
  }
  .pp-name {
    font-size: 19px;
    line-height: 26px;
  }
}
@container (max-width: 420px) {
  .pp-bar-title small {
    display: none;
  }
  .pp-buy {
    flex-direction: column;
  }
  .pp-qty {
    align-self: flex-start;
  }
  .pp-specs {
    grid-template-columns: 1fr;
  }
  .pp-specs dt {
    border-bottom: 0;
    padding-bottom: 2px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/product-preview-detail/product-preview-detail.component.scss"],"names":[],"mappings":"AACA;EACC,cAAA;EACA,2BAAA;EACA,cAAA;EACA,eAAA;AAAD;;AAGA;EACC,cAAA;AAAD;;AAGA;EACC,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,gBAAA;AAAD;;AAGA,kCAAA;AACA;EACC,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,4BAAA;EACA,gCAAA;EACA,mBAAA;EACA,cAAA;AAAD;;AAGA;EACC,aAAA;EACA,mBAAA;EACA,SAAA;AAAD;AAEC;EACC,aAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,+DAAA;EACA,2BAAA;EACA,eAAA;AAAF;AAGC;EACC,cAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AADF;AAIC;EACC,cAAA;EACA,eAAA;AAFF;;AAMA;EACC,aAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AAHD;AAKC;EACC,2BAAA;EACA,iEAAA;AAHF;AAOC;EACC,aAAA;AALF;AAQC;EACC,sEAAA;EACA,mBAAA;AANF;;AAUA;EACC,gBAAA;EACA,aAAA;EACA,qBAAA;AAPD;;AAUA,kDAAA;AACA;EACC,aAAA;EACA,oDAAA;EACA,SAAA;EACA,kBAAA;AAPD;;AAUA;EACC,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,iBAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;AAPD;AAUC;EACC,kBAAA;EACA,WAAA;EACA,wBAAA;EACA,yBAAA;EACA,mBAAA;AARF;;AAYA;EACC,aAAA;EACA,qBAAA;EACA,QAAA;EACA,cAAA;EACA,eAAA;AATD;AAWC;EACC,eAAA;AATF;;AAaA;EACC,aAAA;EACA,QAAA;EACA,gBAAA;EACA,gBAAA;EACA,qBAAA;AAVD;;AAaA;EACC,cAAA;EACA,YAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AAVD;AAYC;EACC,WAAA;EACA,YAAA;EACA,mBAAA;AAVF;AAaC;EACC,kCAAA;EACA,0CAAA;AAXF;;AAeA;EACC,YAAA;AAZD;;AAeA;EACC,eAAA;EACA,2BAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;AAZD;;AAeA;EACC,SAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;AAZD;;AAeA;EACC,aAAA;EACA,eAAA;EACA,mBAAA;EACA,aAAA;EACA,gBAAA;AAZD;;AAeA;EACC,oBAAA;EACA,mBAAA;EACA,QAAA;AAZD;AAcC;EACC,cAAA;EACA,eAAA;AAZF;AAeC;EACC,eAAA;AAbF;AAgBC;EACC,sBAAA;AAdF;;AAkBA;EACC,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;AAfD;;AAkBA;EACC,gBAAA;EACA,cAAA;EACA,eAAA;AAfD;AAiBC;EACC,cAAA;EACA,gBAAA;AAfF;;AAmBA;EACC,aAAA;EACA,eAAA;EACA,qBAAA;EACA,QAAA;EACA,gBAAA;EACA,iBAAA;EACA,6BAAA;AAhBD;AAkBC;EACC,cAAA;EACA,eAAA;EACA,gBAAA;AAhBF;AAmBC;EACC,cAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AAjBF;AAoBC;EACC,cAAA;EACA,eAAA;AAlBF;;AAsBA;EACC,eAAA;EACA,cAAA;EACA,eAAA;AAnBD;;AAsBA;EACC,gBAAA;AAnBD;;AAsBA;EACC,cAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;AAnBD;;AAsBA;EACC,aAAA;EACA,eAAA;EACA,QAAA;AAnBD;;AAsBA;EACC,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,aAAA;EACA,eAAA;EACA,eAAA;AAnBD;AAqBC;EACC,iEAAA;AAnBF;AAsBC;EACC,kCAAA;EACA,8DAAA;EACA,2BAAA;EACA,gBAAA;AApBF;;AAwBA;EACC,aAAA;EACA,SAAA;EACA,gBAAA;AArBD;;AAwBA;EACC,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AArBD;AAuBC;EACC,aAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,mBAAA;EACA,cAAA;EACA,mBAAA;AArBF;AAuBE;EACC,eAAA;AArBH;AAyBC;EACC,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AAvBF;;AA2BA;EACC,OAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,YAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;EACA,WAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;AAxBD;AA0BC;EACC,eAAA;AAxBF;;AA4BA;EACC,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AAzBD;AA2BC;EACC,eAAA;AAzBF;;AA6BA;EACC,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,2BAAA;EACA,eAAA;EACA,gBAAA;AA1BD;AA4BC;EACC,eAAA;AA1BF;;AA8BA,+BAAA;AACA;EACC,aAAA;EACA,QAAA;EACA,gBAAA;EACA,gCAAA;EACA,gBAAA;EACA,qBAAA;AA3BD;AA6BC;EACC,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,SAAA;EACA,oCAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;AA3BF;AA6BE;EACC,cAAA;AA3BH;AA8BE;EACC,2BAAA;EACA,yCAAA;AA5BH;;AAiCA;EACC,cAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;AA9BD;;AAiCA;EACC,mBAAA;AA9BD;AAgCC;EACC,gBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AA9BF;;AAkCA;EACC,SAAA;EACA,cAAA;EACA,iBAAA;EACA,qBAAA;AA/BD;;AAkCA;EACC,SAAA;EACA,cAAA;AA/BD;;AAkCA;EACC,aAAA;EACA,qBAAA;EACA,QAAA;EACA,kBAAA;EACA,0BAAA;EACA,mBAAA;EACA,cAAA;AA/BD;AAiCC;EACC,eAAA;EACA,cAAA;AA/BF;AAkCC;EACC,SAAA;EACA,eAAA;AAhCF;;AAoCA;EACC,aAAA;EACA,+CAAA;EACA,SAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;AAjCD;AAmCC;;EAEC,SAAA;EACA,kBAAA;EACA,gCAAA;AAjCF;AAoCC;EACC,mBAAA;EACA,cAAA;EACA,eAAA;AAlCF;AAqCC;EACC,cAAA;AAnCF;AAsCC;;EAEC,gBAAA;AApCF;;AAwCA;EACC,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AArCD;AAuCC;EACC,cAAA;EACA,eAAA;AArCF;AAwCC;EACC,cAAA;AAtCF;;AA0CA;EACC,eAAA;EACA,6BAAA;AAvCD;AAyCC;EACC,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;AAvCF;AAyCE;EACC,cAAA;AAvCH;AA0CE;EACC,eAAA;AAxCH;AA4CC;EACC,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;AA1CF;AA6CC;EACC,eAAA;EACA,cAAA;EACA,iBAAA;AA3CF;;AA+CA;EACC,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;AA5CD;AA8CC;EACC,eAAA;AA5CF;;AAgDA;EACC,gBAAA;AA7CD;;AAgDA;EACC,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,qBAAA;AA7CD;AA+CC;EACC,2BAAA;EACA,eAAA;AA7CF;AAgDC;EACC,cAAA;EACA,eAAA;AA9CF;AAiDC;EACC,iEAAA;AA/CF;AAiDE;EACC,2BAAA;AA/CH;;AAoDA;EACC,OAAA;EACA,YAAA;AAjDD;AAmDC;EACC,cAAA;EACA,cAAA;EACA,gBAAA;AAjDF;AAoDC;EACC,cAAA;EACA,eAAA;AAlDF;;AAsDA,2CAAA;AACA;EACC,gBAAA;EACA,iBAAA;EACA,6BAAA;AAnDD;AAqDC;EACC,gBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAnDF;;AAuDA;EACC,aAAA;EACA,sBAAA;EACA,wBAAA;EACA,SAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;AApDD;;AAuDA;EACC,aAAA;EACA,QAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;AApDD;AAsDC;EACC,cAAA;EACA,eAAA;AApDF;AAuDC;EACC,cAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;AArDF;;AAyDA;EACC,aAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;AAtDD;AAwDC;EACC,eAAA;EACA,gBAAA;EACA,mBAAA;AAtDF;;AA0DA;EACC,cAAA;EACA,gBAAA;EACA,eAAA;AAvDD;;AA0DA,2EAAA;AACA;EACC,4CAAA;EACA,6CAAA;EACA,+CAAA;EACA,gDAAA;EACA,uEAAA;EACA,wEAAA;EACA,6DAAA;EACA,6DAAA;EACA,mEAAA;EACA,qBAAA;AAvDD;;AA0DA;;;;;;;;;;;EAWC,oBAAA;AAvDD;;AA0DA;;;;EAIC,qBAAA;AAvDD;;AA0DA;;;;EAIC,qBAAA;AAvDD;;AA0DA;;;;;;;;;;;;;;;;EAgBC,sBAAA;AAvDD;;AA0DA;;;;;;;;;EASC,8BAAA;AAvDD;;AA0DA;;;;;;;EAOC,+BAAA;AAvDD;;AA0DA;;;;;EAKC,0BAAA;AAvDD;;AA0DA;;EAEC,0BAAA;EACA,0BAAA;AAvDD;;AA2DA;;;;EAIC,2BAAA;AAxDD;;AA2DA;EACC,qBAAA;AAxDD;;AA2DA;;EAEC,kCAAA;AAxDD;;AA2DA,qCAAA;AACA;EACC;IACC,0BAAA;IACA,SAAA;EAxDA;EA2DD;IACC,iBAAA;EAzDA;EA4DD;IACC,aAAA;EA1DA;EA6DD;IACC,eAAA;IACA,iBAAA;EA3DA;AACF;AA8DA;EACC;IACC,aAAA;EA5DA;EA+DD;IACC,sBAAA;EA7DA;EAgED;IACC,sBAAA;EA9DA;EAiED;IACC,0BAAA;EA/DA;EAiEA;IACC,gBAAA;IACA,mBAAA;EA/DD;AACF","sourcesContent":["// Customer preview dialog - same design tokens as the supplier list/view pages\n:host {\n\tdisplay: block;\n\tcontainer-type: inline-size;\n\tcolor: #253750;\n\tfont-size: 13px;\n}\n\n.material-symbols-outlined {\n\tline-height: 1;\n}\n\n.pp {\n\tdisplay: flex;\n\tflex-direction: column;\n\tmax-height: 90vh;\n\tbackground: #fff;\n}\n\n/* ---------- top bar ---------- */\n.pp-bar {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tgap: 12px;\n\tpadding: 12px 16px 12px 20px;\n\tborder-bottom: 1px solid #edf1f6;\n\tbackground: #fbfcfe;\n\tflex-shrink: 0;\n}\n\n.pp-bar-title {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 10px;\n\n\t>.material-symbols-outlined {\n\t\tdisplay: grid;\n\t\tplace-items: center;\n\t\twidth: 32px;\n\t\theight: 32px;\n\t\tborder-radius: 8px;\n\t\tbackground: color-mix(in srgb, var(--primary-color) 10%, white);\n\t\tcolor: var(--primary-color);\n\t\tfont-size: 18px;\n\t}\n\n\tstrong {\n\t\tdisplay: block;\n\t\tcolor: #172b46;\n\t\tfont-size: 13px;\n\t\tfont-weight: 600;\n\t}\n\n\tsmall {\n\t\tcolor: #7d8a9d;\n\t\tfont-size: 11px;\n\t}\n}\n\n.pp-close {\n\tdisplay: grid;\n\tplace-items: center;\n\twidth: 34px;\n\theight: 34px;\n\tborder: 1px solid #dce5ef;\n\tborder-radius: 8px;\n\tbackground: #fff;\n\tcolor: #53647a;\n\tcursor: pointer;\n\n\t&:hover {\n\t\tcolor: var(--primary-color);\n\t\tborder-color: color-mix(in srgb, var(--primary-color) 25%, white);\n\t}\n\n\t// dialog auto-focuses this button: only show a ring for keyboard focus\n\t&:focus {\n\t\toutline: none;\n\t}\n\n\t&:focus-visible {\n\t\toutline: 2px solid color-mix(in srgb, var(--primary-color) 40%, white);\n\t\toutline-offset: 2px;\n\t}\n}\n\n.pp-body {\n\toverflow-y: auto;\n\tpadding: 24px;\n\tscrollbar-width: thin;\n}\n\n/* ---------- hero: gallery + buy box ---------- */\n.pp-hero {\n\tdisplay: grid;\n\tgrid-template-columns: minmax(0, 1fr) minmax(0, 1fr);\n\tgap: 32px;\n\talign-items: start;\n}\n\n.pp-main-image {\n\tdisplay: grid;\n\tplace-items: center;\n\taspect-ratio: 1 / 1;\n\tmax-height: 420px;\n\twidth: 100%;\n\tborder: 1px solid #edf1f6;\n\tborder-radius: 12px;\n\tbackground: #fbfcfe;\n\toverflow: hidden;\n\tposition: relative;\n\n\t// absolute so the size resolves against the aspect-ratio box (never crops)\n\timg {\n\t\tposition: absolute;\n\t\tinset: 20px;\n\t\twidth: calc(100% - 40px);\n\t\theight: calc(100% - 40px);\n\t\tobject-fit: contain;\n\t}\n}\n\n.pp-no-image {\n\tdisplay: grid;\n\tjustify-items: center;\n\tgap: 6px;\n\tcolor: #8491a3;\n\tfont-size: 12px;\n\n\t.material-symbols-outlined {\n\t\tfont-size: 36px;\n\t}\n}\n\n.pp-thumbs {\n\tdisplay: flex;\n\tgap: 8px;\n\tmargin-top: 10px;\n\toverflow-x: auto;\n\tscrollbar-width: thin;\n}\n\n.pp-thumb {\n\tflex: 0 0 64px;\n\theight: 64px;\n\tpadding: 4px;\n\tborder: 1px solid #e2e9f2;\n\tborder-radius: 8px;\n\tbackground: #fff;\n\tcursor: pointer;\n\n\timg {\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\tobject-fit: contain;\n\t}\n\n\t&.active {\n\t\tborder-color: var(--primary-color);\n\t\tbox-shadow: 0 0 0 1px var(--primary-color);\n\t}\n}\n\n.pp-info {\n\tmin-width: 0;\n}\n\n.pp-brand {\n\tmargin: 0 0 6px;\n\tcolor: var(--primary-color);\n\tfont-size: 11px;\n\tfont-weight: 600;\n\tletter-spacing: .4px;\n\ttext-transform: uppercase;\n}\n\n.pp-name {\n\tmargin: 0;\n\tcolor: #172b46;\n\tfont-size: 22px;\n\tline-height: 30px;\n\tfont-weight: 600;\n\toverflow-wrap: anywhere;\n}\n\n.pp-meta {\n\tdisplay: flex;\n\tflex-wrap: wrap;\n\talign-items: center;\n\tgap: 8px 16px;\n\tmargin-top: 10px;\n}\n\n.pp-rating {\n\tdisplay: inline-flex;\n\talign-items: center;\n\tgap: 6px;\n\n\tsmall {\n\t\tcolor: #8491a3;\n\t\tfont-size: 11px;\n\t}\n\n\t::ng-deep .ant-rate {\n\t\tfont-size: 14px;\n\t}\n\n\t::ng-deep .ant-rate-star:not(:last-child) {\n\t\tmargin-inline-end: 3px;\n\t}\n}\n\n.pp-sku {\n\tpadding: 2px 8px;\n\tborder-radius: 5px;\n\tbackground: #f1f6fd;\n\tcolor: #6480a4;\n\tfont-size: 11px;\n}\n\n.pp-seller {\n\tmargin: 10px 0 0;\n\tcolor: #7d8a9d;\n\tfont-size: 12px;\n\n\tstrong {\n\t\tcolor: #35445b;\n\t\tfont-weight: 500;\n\t}\n}\n\n.pp-price {\n\tdisplay: flex;\n\tflex-wrap: wrap;\n\talign-items: baseline;\n\tgap: 6px;\n\tmargin-top: 20px;\n\tpadding-top: 18px;\n\tborder-top: 1px solid #edf1f6;\n\n\t.pp-currency {\n\t\tcolor: #35445b;\n\t\tfont-size: 14px;\n\t\tfont-weight: 600;\n\t}\n\n\t.pp-amount {\n\t\tcolor: #172b46;\n\t\tfont-size: 28px;\n\t\tline-height: 1;\n\t\tfont-weight: 700;\n\t}\n\n\t.pp-unit {\n\t\tcolor: #7d8a9d;\n\t\tfont-size: 12px;\n\t}\n}\n\n.pp-vat {\n\tmargin: 6px 0 0;\n\tcolor: #8491a3;\n\tfont-size: 11px;\n}\n\n.pp-option {\n\tmargin-top: 18px;\n}\n\n.pp-option-label {\n\tdisplay: block;\n\tmargin-bottom: 8px;\n\tcolor: #53647a;\n\tfont-size: 11px;\n\tfont-weight: 500;\n\tletter-spacing: .3px;\n\ttext-transform: uppercase;\n}\n\n.pp-chips {\n\tdisplay: flex;\n\tflex-wrap: wrap;\n\tgap: 8px;\n}\n\n.pp-chip {\n\tmin-height: 34px;\n\tpadding: 6px 14px;\n\tborder: 1px solid #dce5ef;\n\tborder-radius: 8px;\n\tbackground: #fff;\n\tcolor: #35445b;\n\tfont: inherit;\n\tfont-size: 12px;\n\tcursor: pointer;\n\n\t&:hover {\n\t\tborder-color: color-mix(in srgb, var(--primary-color) 30%, white);\n\t}\n\n\t&.active {\n\t\tborder-color: var(--primary-color);\n\t\tbackground: color-mix(in srgb, var(--primary-color) 7%, white);\n\t\tcolor: var(--primary-color);\n\t\tfont-weight: 500;\n\t}\n}\n\n.pp-buy {\n\tdisplay: flex;\n\tgap: 10px;\n\tmargin-top: 22px;\n}\n\n.pp-qty {\n\tdisplay: inline-flex;\n\talign-items: center;\n\theight: 44px;\n\tborder: 1px solid #dce5ef;\n\tborder-radius: 8px;\n\toverflow: hidden;\n\n\tbutton {\n\t\tdisplay: grid;\n\t\tplace-items: center;\n\t\twidth: 38px;\n\t\theight: 100%;\n\t\tborder: 0;\n\t\tbackground: #fbfcfe;\n\t\tcolor: #8491a3;\n\t\tcursor: not-allowed;\n\n\t\t.material-symbols-outlined {\n\t\t\tfont-size: 18px;\n\t\t}\n\t}\n\n\t>span {\n\t\tmin-width: 40px;\n\t\ttext-align: center;\n\t\tfont-weight: 600;\n\t\tcolor: #172b46;\n\t}\n}\n\n.pp-cart {\n\tflex: 1;\n\tdisplay: inline-flex;\n\talign-items: center;\n\tjustify-content: center;\n\tgap: 8px;\n\theight: 44px;\n\tborder: 0;\n\tborder-radius: 8px;\n\tbackground: var(--primary-color);\n\tcolor: #fff;\n\tfont: inherit;\n\tfont-size: 13px;\n\tfont-weight: 600;\n\topacity: .55;\n\tcursor: not-allowed;\n\n\t.material-symbols-outlined {\n\t\tfont-size: 20px;\n\t}\n}\n\n.pp-note {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 6px;\n\tmargin: 10px 0 0;\n\tcolor: #8491a3;\n\tfont-size: 11px;\n\n\t.material-symbols-outlined {\n\t\tfont-size: 15px;\n\t}\n}\n\n.pp-sample {\n\tdisplay: inline-flex;\n\talign-items: center;\n\tgap: 6px;\n\tmargin-top: 14px;\n\tcolor: var(--primary-color);\n\tfont-size: 12px;\n\tfont-weight: 500;\n\n\t.material-symbols-outlined {\n\t\tfont-size: 18px;\n\t}\n}\n\n/* ---------- tabs ---------- */\n.pp-tabs {\n\tdisplay: flex;\n\tgap: 4px;\n\tmargin-top: 32px;\n\tborder-bottom: 1px solid #e2e9f2;\n\toverflow-x: auto;\n\tscrollbar-width: none;\n\n\tbutton {\n\t\tdisplay: inline-flex;\n\t\talign-items: center;\n\t\tgap: 6px;\n\t\tpadding: 10px 14px;\n\t\tborder: 0;\n\t\tborder-bottom: 2px solid transparent;\n\t\tmargin-bottom: -1px;\n\t\tbackground: transparent;\n\t\tcolor: #7d8a9d;\n\t\tfont: inherit;\n\t\tfont-size: 13px;\n\t\tfont-weight: 500;\n\t\twhite-space: nowrap;\n\t\tcursor: pointer;\n\n\t\t&:hover {\n\t\t\tcolor: #35445b;\n\t\t}\n\n\t\t&.active {\n\t\t\tcolor: var(--primary-color);\n\t\t\tborder-bottom-color: var(--primary-color);\n\t\t}\n\t}\n}\n\n.pp-count {\n\tpadding: 0 6px;\n\tborder-radius: 10px;\n\tbackground: #f1f3f7;\n\tcolor: #7d8a9d;\n\tfont-size: 10px;\n\tline-height: 16px;\n}\n\n.pp-panel {\n\tpadding: 20px 0 4px;\n\n\th3 {\n\t\tmargin: 0 0 10px;\n\t\tcolor: #172b46;\n\t\tfont-size: 14px;\n\t\tfont-weight: 600;\n\t}\n}\n\n.pp-desc {\n\tmargin: 0;\n\tcolor: #53647a;\n\tline-height: 1.65;\n\twhite-space: pre-wrap;\n}\n\n.pp-empty {\n\tmargin: 0;\n\tcolor: #8491a3;\n}\n\n.pp-empty-state {\n\tdisplay: grid;\n\tjustify-items: center;\n\tgap: 6px;\n\tpadding: 28px 12px;\n\tborder: 1px dashed #dce5ef;\n\tborder-radius: 10px;\n\tcolor: #8491a3;\n\n\t.material-symbols-outlined {\n\t\tfont-size: 28px;\n\t\tcolor: #a9bad1;\n\t}\n\n\tp {\n\t\tmargin: 0;\n\t\tfont-size: 12px;\n\t}\n}\n\n.pp-specs {\n\tdisplay: grid;\n\tgrid-template-columns: minmax(140px, 220px) 1fr;\n\tmargin: 0;\n\tborder: 1px solid #e2e9f2;\n\tborder-radius: 10px;\n\toverflow: hidden;\n\n\tdt,\n\tdd {\n\t\tmargin: 0;\n\t\tpadding: 11px 14px;\n\t\tborder-bottom: 1px solid #edf1f6;\n\t}\n\n\tdt {\n\t\tbackground: #fbfcfe;\n\t\tcolor: #7d8a9d;\n\t\tfont-size: 12px;\n\t}\n\n\tdd {\n\t\tcolor: #35445b;\n\t}\n\n\tdt:nth-last-of-type(1),\n\tdd:last-child {\n\t\tborder-bottom: 0;\n\t}\n}\n\n.pp-review-summary {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 10px;\n\tmargin-bottom: 14px;\n\n\tstrong {\n\t\tcolor: #172b46;\n\t\tfont-size: 26px;\n\t}\n\n\tsmall {\n\t\tcolor: #8491a3;\n\t}\n}\n\n.pp-review {\n\tpadding: 14px 0;\n\tborder-top: 1px solid #edf1f6;\n\n\t.pp-review-head {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: space-between;\n\t\tgap: 10px;\n\n\t\tstrong {\n\t\t\tcolor: #172b46;\n\t\t}\n\n\t\t::ng-deep .ant-rate {\n\t\t\tfont-size: 12px;\n\t\t}\n\t}\n\n\tsmall {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tgap: 8px;\n\t\tmargin-top: 2px;\n\t\tcolor: #8491a3;\n\t\tfont-size: 11px;\n\t}\n\n\tp {\n\t\tmargin: 8px 0 0;\n\t\tcolor: #53647a;\n\t\tline-height: 1.55;\n\t}\n}\n\n.pp-verified {\n\tdisplay: inline-flex;\n\talign-items: center;\n\tgap: 3px;\n\tcolor: #36866a;\n\n\t.material-symbols-outlined {\n\t\tfont-size: 14px;\n\t}\n}\n\n.pp-doc-group+.pp-doc-group {\n\tmargin-top: 18px;\n}\n\n.pp-doc {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 12px;\n\tpadding: 12px 14px;\n\tmargin-bottom: 8px;\n\tborder: 1px solid #e2e9f2;\n\tborder-radius: 10px;\n\tcolor: inherit;\n\ttext-decoration: none;\n\n\t>.material-symbols-outlined:first-child {\n\t\tcolor: var(--primary-color);\n\t\tfont-size: 22px;\n\t}\n\n\t>.material-symbols-outlined:last-child {\n\t\tcolor: #8491a3;\n\t\tfont-size: 20px;\n\t}\n\n\t&:hover {\n\t\tborder-color: color-mix(in srgb, var(--primary-color) 30%, white);\n\n\t\t>.material-symbols-outlined:last-child {\n\t\t\tcolor: var(--primary-color);\n\t\t}\n\t}\n}\n\n.pp-doc-text {\n\tflex: 1;\n\tmin-width: 0;\n\n\tstrong {\n\t\tdisplay: block;\n\t\tcolor: #172b46;\n\t\tfont-weight: 500;\n\t}\n\n\tsmall {\n\t\tcolor: #8491a3;\n\t\tfont-size: 11px;\n\t}\n}\n\n/* ---------- related products ---------- */\n.pp-related {\n\tmargin-top: 28px;\n\tpadding-top: 20px;\n\tborder-top: 1px solid #edf1f6;\n\n\th3 {\n\t\tmargin: 0 0 12px;\n\t\tcolor: #172b46;\n\t\tfont-size: 14px;\n\t\tfont-weight: 600;\n\t}\n}\n\n.pp-related-row {\n\tdisplay: grid;\n\tgrid-auto-flow: column;\n\tgrid-auto-columns: 170px;\n\tgap: 12px;\n\toverflow-x: auto;\n\tpadding-bottom: 6px;\n\tscrollbar-width: thin;\n}\n\n.pp-card {\n\tdisplay: grid;\n\tgap: 4px;\n\tpadding: 10px;\n\tborder: 1px solid #e2e9f2;\n\tborder-radius: 10px;\n\n\tsmall {\n\t\tcolor: #8491a3;\n\t\tfont-size: 10px;\n\t}\n\n\tstrong {\n\t\tcolor: #172b46;\n\t\tfont-size: 12px;\n\t\tfont-weight: 500;\n\t\tdisplay: -webkit-box;\n\t\t-webkit-line-clamp: 2;\n\t\t-webkit-box-orient: vertical;\n\t\toverflow: hidden;\n\t}\n}\n\n.pp-card-img {\n\tdisplay: grid;\n\tplace-items: center;\n\theight: 120px;\n\tmargin-bottom: 6px;\n\tborder-radius: 8px;\n\tbackground: #fbfcfe;\n\tcolor: #a9bad1;\n\n\timg {\n\t\tmax-width: 100%;\n\t\tmax-height: 100%;\n\t\tobject-fit: contain;\n\t}\n}\n\n.pp-card-price {\n\tcolor: #172b46;\n\tfont-weight: 600;\n\tfont-size: 12px;\n}\n\n/* ---------- theme tokens (all colours from the theme config) ---------- */\n:host {\n\t--pp-ink: var(--primary-font-color, #172b46);\n\t--pp-text: var(--primary-font-color, #35445b);\n\t--pp-body: var(--secondary-grey-color, #53647a);\n\t--pp-muted: var(--secondary-grey-color, #8491a3);\n\t--pp-border: color-mix(in srgb, var(--grey-border, #D5D7DA) 70%, white);\n\t--pp-divider: color-mix(in srgb, var(--grey-border, #D5D7DA) 45%, white);\n\t--pp-soft: color-mix(in srgb, var(--primary-color) 3%, white);\n\t--pp-tint: color-mix(in srgb, var(--primary-color) 8%, white);\n\t--pp-tint-text: color-mix(in srgb, var(--primary-color) 75%, black);\n\tcolor: var(--pp-text);\n}\n\n.pp-name,\n.pp-bar-title strong,\n.pp-price .pp-amount,\n.pp-qty>span,\n.pp-panel h3,\n.pp-related h3,\n.pp-review strong,\n.pp-review-summary strong,\n.pp-doc-text strong,\n.pp-card strong,\n.pp-card-price {\n\tcolor: var(--pp-ink);\n}\n\n.pp-price .pp-currency,\n.pp-seller strong,\n.pp-chip,\n.pp-specs dd {\n\tcolor: var(--pp-text);\n}\n\n.pp-desc,\n.pp-review p,\n.pp-option-label,\n.pp-close {\n\tcolor: var(--pp-body);\n}\n\n.pp-bar-title small,\n.pp-seller,\n.pp-price .pp-unit,\n.pp-vat,\n.pp-note,\n.pp-rating small,\n.pp-tabs button,\n.pp-empty,\n.pp-empty-state,\n.pp-specs dt,\n.pp-review small,\n.pp-review-summary small,\n.pp-doc-text small,\n.pp-card small,\n.pp-no-image,\n.pp-qty button {\n\tcolor: var(--pp-muted);\n}\n\n.pp-close,\n.pp-thumb,\n.pp-chip,\n.pp-qty,\n.pp-empty-state,\n.pp-specs,\n.pp-doc,\n.pp-card,\n.pp-tabs {\n\tborder-color: var(--pp-border);\n}\n\n.pp-bar,\n.pp-main-image,\n.pp-price,\n.pp-specs dt,\n.pp-specs dd,\n.pp-review,\n.pp-related {\n\tborder-color: var(--pp-divider);\n}\n\n.pp-bar,\n.pp-main-image,\n.pp-qty button,\n.pp-specs dt,\n.pp-card-img {\n\tbackground: var(--pp-soft);\n}\n\n.pp-sku,\n.pp-count {\n\tbackground: var(--pp-tint);\n\tcolor: var(--pp-tint-text);\n}\n\n// keep interactive states on the brand colour\n.pp-tabs button.active,\n.pp-chip.active,\n.pp-close:hover,\n.pp-doc:hover>.material-symbols-outlined:last-child {\n\tcolor: var(--primary-color);\n}\n\n.pp-tabs button:hover:not(.active) {\n\tcolor: var(--pp-text);\n}\n\n.pp-chip.active,\n.pp-thumb.active {\n\tborder-color: var(--primary-color);\n}\n\n/* ---------- responsive ---------- */\n@container (max-width: 720px) {\n\t.pp-hero {\n\t\tgrid-template-columns: 1fr;\n\t\tgap: 20px;\n\t}\n\n\t.pp-main-image {\n\t\tmax-height: 300px;\n\t}\n\n\t.pp-body {\n\t\tpadding: 16px;\n\t}\n\n\t.pp-name {\n\t\tfont-size: 19px;\n\t\tline-height: 26px;\n\t}\n}\n\n@container (max-width: 420px) {\n\t.pp-bar-title small {\n\t\tdisplay: none;\n\t}\n\n\t.pp-buy {\n\t\tflex-direction: column;\n\t}\n\n\t.pp-qty {\n\t\talign-self: flex-start;\n\t}\n\n\t.pp-specs {\n\t\tgrid-template-columns: 1fr;\n\n\t\tdt {\n\t\t\tborder-bottom: 0;\n\t\t\tpadding-bottom: 2px;\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
